module.exports = __webpack_public_path__ + "static/img/10.0c408c18.jpg";